import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import MessageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { ModalClose } from "../../atoms/modalClose";
import { ErrorMassage } from "../../molecules/errorMassage";
import { PullDownOptionForm } from "../../molecules/pullDownOptionForm";
import { RadioButtonForm } from "../../molecules/radioButtonForm";
import { getRestaurantList, getMealCourseList, getMealStartTimeList, getShuttleBusTimeList, getAgreeInfo, getOpenRestaurantList, getCourseListFromPlan } from '../../../const';
import Const from "../../../const/Const";


const InputUserPopupContainer = (props) => {
    const {
        login,
        state,
        mealInfoList,
        setMealInfoList,
        otherMenuInfoList,
        setOtherMenuInfoList,
        membershipSearchParam,
        setMembershipSearchParam,
        membershipReserveInfo,
        setMembershipReserveInfo,
        inputUserInfo,
        setInputUserInfo,
        setPopupMode,
        setPopupData,
        setPopupMessage,
        onClickOpenPopupWindow,
        onClickClosePopupWindow,
        onClickOpenCoursePopup
    } = props;
    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupTitle = state.popupTitle ? state.popupTitle : "　";
    const popupMode = state.popupMode;
    const [courseNumList, setCourseNumList] = useState([]);
    const [menuDateList, setMenuDateList] = useState([]);
    const [adultNumList, setAdultNumList] = useState([]);
    const [childNumList, setChildNumList] = useState([]);
    const [preschoolerNumList, setPreschoolerNumList] = useState([]);
    const [babyNumList, setBabyNumList] = useState([]);
    let dataList = [];
    let popupData = state.popupData;
    let restaurantInfo = { restaurantCd: "", restaurantName: "" };
    let footerClass = "";
    const popupRef = useRef(null);
    const [errorInfo, setErrorInfo] = useState({ errorFlg: false, errorMessageBox: [] });
    
    const [riyoNinzuState, setRiyoNinzuState] = useState({adult:0, child:0, preschooler:0, baby:0});
    const handleChangeSelect = (event, name) => {
      setRiyoNinzuState((prev) => ({ ...prev, [name]: Number(event.target.value) }));
    };

    if (popupMode == 'dinner') {
        footerClass = "none";
        dataList = popupData.restaurantList ? popupData.restaurantList : [];
    } else if (popupMode == 'breakfast') {
        footerClass = "none";
        dataList = popupData.restaurantList ? popupData.restaurantList : [];
    } else if (popupMode == 'riyoNinzu') {
        footerClass = "selectTime"
    } else if (popupMode == 'mealTime') {
        footerClass = mealInfoList && mealInfoList[popupData.targetIndex]?.selectCourseFlg ? "selectCourse" : "decision";
        dataList = popupData.selectTimeList;
    } else if (popupMode == 'course') {
        footerClass = "decision";
        dataList = popupData.courseList;
    } else if (popupMode == "shuttleBusTime") {
        footerClass = "decision";
        dataList = popupData.selectTimeList
    } else if (popupMode == "otherMenuTime") {
        footerClass = "selectCourse";
        dataList = popupData.selectTimeList
    } else if (popupMode == "otherMenuCourse") {
        footerClass = "decision";
        dataList = popupData.courseList;
    } else if (popupMode == "doiInfo" || popupMode == "serviceInfo" || popupMode == "error") {
        footerClass = "message"
    }
    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);
    useEffect(() => {
        if (!state.membershipPopup) {
            // 閉じられた際に一度表示をクリアするためにコース人数リストを空にする
            setCourseNumList([]);
            return;
        }
        popupRef.current.scrollTop = 0;
        if (popupMode == "course" || popupMode == "otherMenuCourse") {
            let numList = [];
            const currentNinzu = inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt;
            const prevNinzu = mealInfoList[popupData.targetIndex].riyoNinzu;
            // 素泊まり
            if (mealInfoList[popupData.targetIndex].riyoNinzuFlg) {
                for (let i = 0; i <= prevNinzu; i++) {
                    numList.push({ id: i, value: i });
                }
            }
            // ディナーチョイスのディナー
            else if(!mealInfoList[popupData.targetIndex].planRestaurantList?.length && currentNinzu <= prevNinzu) {
                for (let i = 0; i <= prevNinzu; i++) {
                    numList.push({ id: i, value: i });
                }
            }
            // その他
            else {
                for (let i = 0; i <= currentNinzu; i++) {
                    // 大人 + 小人 + 幼児
                    numList.push({ id: i, value: i });
                }
            }
            setCourseNumList(numList);
        } else if (popupMode == "otherMenuTime") {
            let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, membershipSearchParam.checkOutDate, "yyyy-MM-dd");
            let newMenuDateList = [];
            dateList.forEach(value => {
                newMenuDateList.push({ text: value.slice(5, 7) + "月" + value.slice(8) + "日", value: value, selected: value == otherMenuInfoList[popupData.targetIndex].menuDate })
            });
            setMenuDateList(newMenuDateList);
        } else if (popupMode == 'riyoNinzu') {
            let newAdultNumList = [];
            let {adultCnt, childCnt, preschoolerCnt, babyCnt} = mealInfoList[popupData.targetIndex];
            const isNinzuSelected = !!mealInfoList && !!mealInfoList[popupData.targetIndex]?.restaurantCd;
            adultCnt = adultCnt < inputUserInfo.adultCnt ? adultCnt : inputUserInfo.adultCnt;
            childCnt = childCnt < inputUserInfo.childCnt ? childCnt : inputUserInfo.childCnt; 
            preschoolerCnt = preschoolerCnt < inputUserInfo.preschoolerCnt ? preschoolerCnt : inputUserInfo.preschoolerCnt; 
            babyCnt = babyCnt < inputUserInfo.babyCnt ? babyCnt : inputUserInfo.babyCnt; 

            for (let i = 0; i <= inputUserInfo.adultCnt; i++) {
                newAdultNumList.push({ id: i, value: i, selected: isNinzuSelected && i == adultCnt });
            }
            let newChildNumList = [];
            for (let i = 0; i <= inputUserInfo.childCnt; i++) {
                newChildNumList.push({ id: i, value: i, selected: isNinzuSelected && i == childCnt });
            }
            let newPreschoolerNumList = [];
            for (let i = 0; i <= inputUserInfo.preschoolerCnt; i++) {
                newPreschoolerNumList.push({ id: i, value: i, selected: isNinzuSelected && i == preschoolerCnt });
            }
            let newBabyNumList = [];
            for (let i = 0; i <= inputUserInfo.babyCnt; i++) {
                newBabyNumList.push({ id: i, value: i, selected: isNinzuSelected && i == babyCnt });
            }
            setAdultNumList(newAdultNumList)
            setChildNumList(newChildNumList)
            setPreschoolerNumList(newPreschoolerNumList)
            setBabyNumList(newBabyNumList)

            const states = {
              adult: isNinzuSelected ? adultCnt : inputUserInfo.adultCnt, 
              child: isNinzuSelected ? childCnt : inputUserInfo.childCnt, 
              preschooler: isNinzuSelected ? preschoolerCnt : inputUserInfo.preschoolerCnt, 
              baby: isNinzuSelected ? babyCnt : inputUserInfo.babyCnt
            };
            setRiyoNinzuState(states);
        } else if (popupMode == 'serviceInfo') {
            if (document.getElementById("popupText")) {
                let element = document.getElementById("popupText");
                element.innerHTML = commonUtil.replaceSpecialChar(popupData.serviceInfo.serviceText ? popupData.serviceInfo.serviceText : "");
            }
        } else if (popupMode == 'mealTime') {
            // 表示時の初期選択状態のセット
            const mealTime = mealInfoList[popupData.targetIndex]?.mealTime
            document.getElementsByName('selectTime').forEach(e => {
                e.checked = e.value == mealTime
            });
        } else if (popupMode == 'error') {
            if (document.getElementById("popupText")) {
                let element = document.getElementById("popupText");
                element.innerHTML = commonUtil.replaceSpecialChar(popupData.message ? popupData.message : "");
            }
        }
        setErrorInfo({ errorFlg: false, errorMessageBox: [] });
    }, [popupMode, state.membershipPopup]);

    // プランコース一覧取得後処理
    const afterGetCourseListFromPlan = (res) => {
        let data = res.data
        if (data.resultCode == 0) {
            // ディナーチョイスプランの判定
            const isDinnerChoicePlan = (() => {
                // ディナー付きプラン以外は除外する
                if (!membershipReserveInfo.dinnerTsukiPlanFlg) {
                    return false;
                }
                let reservedRestaurants = []; // プラン指定のレストラン一覧
                if (data.riyoDateJikanKbnList && data.riyoDateJikanKbnList.length) {
                    // 全利用時間から選択中の利用時間データを取得する
                    const riyoJikan = data.riyoDateJikanKbnList.find(riyoJikan => {
                        return riyoJikan.jikantaiKbn == mealInfoList[popupData.targetIndex].jikantaiKbn &&
                            riyoJikan.restaurantRiyoDate == mealInfoList[popupData.targetIndex].restaurantRiyoDate
                    });
                    // 利用時間に紐づくプラン指定のレストランを取得する
                    if (riyoJikan && riyoJikan.restaurantList) {
                        reservedRestaurants = riyoJikan.restaurantList
                    }
                }
                // プラン指定のレストランが無い場合、ディナーチョイスプランとして扱う
                return !reservedRestaurants.length;
            })();
            if (data.riyoDateJikanKbnList && data.riyoDateJikanKbnList.length != 0 && !isDinnerChoicePlan) {
                const targetMealInfo = mealInfoList[popupData.targetIndex];
                const newMealList = mealInfoList.map(mealInfo => {
                    const riyoJikan = data.riyoDateJikanKbnList.find(riyoJikan =>
                        riyoJikan.restaurantRiyoDate === mealInfo.restaurantRiyoDate
                        && riyoJikan.jikantaiKbn == mealInfo.jikantaiKbn
                        && mealInfo.required
                    )
                    if (riyoJikan && riyoJikan.jikantaiKbn == targetMealInfo.jikantaiKbn && riyoJikan.restaurantRiyoDate == targetMealInfo.restaurantRiyoDate) {
                        const restaurant = riyoJikan.restaurantList.find(value => value.restaurantCd == restaurantInfo.restaurantCd);
                        let newDoiList = [];
                        if (restaurant.doiList) {
                            restaurant.doiList.forEach(doiInfo => {
                                newDoiList.push({
                                    doiTitle: doiInfo.doiTitle,
                                    doiSetsumei: doiInfo.doiSetsumei,
                                    doiSetsumeiURL: doiInfo.doiSetsumeiURL,
                                    checked: false
                                });
                            })
                        }
                        setPopupData({
                            targetIndex: popupData.targetIndex,
                            selectTimeList: restaurant.startTimeList
                        });
                        return {
                            ...mealInfo,
                            restaurantCd: restaurant.restaurantCd,
                            restaurantName: restaurant.restaurantName,
                            planRestaurantList: riyoJikan.restaurantList,
                            adultCnt: inputUserInfo.adultCnt,
                            childCnt: inputUserInfo.childCnt,
                            preschoolerCnt: inputUserInfo.preschoolerCnt,
                            babyCnt: inputUserInfo.babyCnt,
                            riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt,
                            mealTime: "",
                            courseList: [],
                            dispCourse: "",
                            doiList: newDoiList
                        }
                    } else {
                        return mealInfo
                    }
                })
                setMealInfoList(newMealList);
                onClickOpenPopupWindow("mealTime", popupData.targetIndex);
            } else {
                let reqAgreeInfo = {
                    honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    restaurantCd: restaurantInfo.restaurantCd,
                    cornerBunKbn: "1"
                }
                let reqMealStartTime = {
                    honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    restaurantCd: restaurantInfo.restaurantCd,
                    restaurantName: restaurantInfo.restaurantName,
                    riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
                    jikantaiKbn: mealInfoList[popupData.targetIndex].jikantaiKbn,
                    riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt,
                }
                let ref = {};
                if (membershipReserveInfo.changeFlg) {
                    let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[popupData.targetIndex].restaurantRiyoDate, "yyyy-MM-dd");
                    let dayCnt = dateList.length;
                    const foodTimeList = inputUserInfo.foodList?.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
                    const foodTimeInfo = foodTimeList?.find(value => value.jikantaiKbn == mealInfoList[popupData.targetIndex].jikantaiKbn && value.restaurantCd == mealInfoList[popupData.targetIndex].restaurantCd)
                    if (foodTimeInfo) {
                        ref = {
                            changeFlg: true,
                            mealTime: foodTimeInfo.startTime
                        }
                    } else {
                        ref = {
                            changeFlg: false,
                        }
                    }
                    common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
                } else {
                    ref = {
                        changeFlg: false,
                    }
                    common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
                }
                common.doPost(getAgreeInfo, reqAgreeInfo, afterGetAgreeInfo);
            }
        } else {
            setErrorInfo({
                errorMessage: data.errorMessage,
                errorFlg: true
            })
            setMealInfoList(mealInfoList);
        }
    }

    // レストラン空き情報取得後処理
    const afterGetOpenRestaurantList = (res, newMealInfoList) => {
        let data = res.data;
        let errorFlg = false;
        let errorMessageBox = [];
        if (data.resultCode == 0 && data.resultFlg == 0) {
            setMealInfoList(newMealInfoList);
            onClickClosePopupWindow();
        } else {
            errorFlg = true;
            errorMessageBox.push(data.errorMessage)
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }
    // 決定
    const onClickDecide = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        if (popupMode == "course") {
            let userSum = 0;
            let totalUserNum = inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt;
            let preschoolerCnt = inputUserInfo.preschoolerCnt;
            let babyCnt = inputUserInfo.babyCnt;
            let newCourseList = [];
            let reqMenuList = [];
            let dispCourse = "";
            dataList.forEach(value => {
                let courseNum = Number(document.getElementById(value.courseCd).value);
                if (courseNum != 0) {
                    userSum += courseNum;
                    newCourseList.push({ courseCd: value.courseCd, courseName: value.courseName, courseNum: courseNum, price: value.price })
                    reqMenuList.push({ menuCd: value.courseCd })
                    dispCourse += (dispCourse == "" ? "" : "、 ") + value.courseName + "：" + courseNum + "人";
                }
            });
            let newList = Array.from(mealInfoList);
            newList.forEach((value, index) => {
                if (index == popupData.targetIndex) {
                    if (value.required && value.planRestaurantList?.length &&
                        (babyCnt > 0 ? (totalUserNum < userSum || (totalUserNum - babyCnt) > userSum) :
                            value.riyoNinzu != userSum)) {
                        // 食事付きプランの場合
                        errorFlg = true;
                        errorMessageBox.push(MessageConst.VALID_INPUT_ERROR)
                    } else if (value.required && !value.planRestaurantList?.length &&
                        ((babyCnt > 0 || preschoolerCnt > 0) ? (totalUserNum < userSum || (totalUserNum - babyCnt - preschoolerCnt) > userSum) :
                            value.riyoNinzu != userSum)) {
                        // ディナーチョイスの場合
                        errorFlg = true;
                        errorMessageBox.push(MessageConst.VALID_INPUT_ERROR)
                    } else if (!value.required && (value.riyoNinzu < userSum || (value.riyoNinzu - value.babyCnt - value.preschoolerCnt) > userSum)) {
                        // 素泊まりプランの場合
                        errorFlg = true;
                        errorMessageBox.push(MessageConst.VALID_INPUT_ERROR)
                    }
                    if (!errorFlg) {
                        value.courseList = newCourseList;
                        value.dispCourse = dispCourse;
                        // ディナチョなら人数も更新
                        if (!mealInfoList[popupData.targetIndex].riyoNinzuFlg && !mealInfoList[popupData.targetIndex].planRestaurantList?.length) {
                            value.riyoNinzu = totalUserNum;
                            value.adultCnt = inputUserInfo.adultCnt;
                            value.childCnt = inputUserInfo.childCnt;
                            value.preschoolerCnt = inputUserInfo.preschoolerCnt;
                            value.babyCnt = inputUserInfo.babyCnt;
                        }
                    }
                }
            });
            if (!errorFlg) {
                if (!membershipReserveInfo.changeFlg) {
                    let req = {
                        keiyakuNo: membershipSearchParam.keiyakuNo,
                        honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                        planCd: membershipReserveInfo.planCd,
                        planShohinCd: membershipReserveInfo.planShohinCd,
                        riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
                        jikantai: mealInfoList[popupData.targetIndex].jikantaiKbn,
                        riyoNinzu: mealInfoList[popupData.targetIndex].riyoNinzu,
                        menuList: reqMenuList,
                        yoyakuStartTime: mealInfoList[popupData.targetIndex].mealTime,
                        restaurantCd: mealInfoList[popupData.targetIndex].restaurantCd
                    };
                    common.doPostRef(getOpenRestaurantList, req, newList, afterGetOpenRestaurantList)
                } else {
                    setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
                    if (!errorFlg) {
                        onClickClosePopupWindow();
                    }
                    return;
                }
            }
        } else if (popupMode == "mealTime") {
            let selectTimeList = document.getElementsByName("selectTime");
            let selectTime = "";
            selectTimeList.forEach(value => {
                if (value.checked) {
                    selectTime = value.value;
                }
            });
            if (selectTime == "") {
                errorFlg = true;
                errorMessageBox.push(MessageConst.VALID_INPUT_ERROR);
            } else {
                let newCourseList = mealInfoList[popupData.targetIndex].courseList || [];
                let dispCourse = mealInfoList[popupData.targetIndex].dispCourse || "";
                if (mealInfoList[popupData.targetIndex].planRestaurantList && mealInfoList[popupData.targetIndex].planRestaurantList.length != 0 && !newCourseList.length) {
                    const restaurantList = mealInfoList[popupData.targetIndex].planRestaurantList;
                    const courseList = restaurantList.find(value => value.restaurantCd == mealInfoList[popupData.targetIndex].restaurantCd).courseList;
                    newCourseList = [];
                    dispCourse = "";
                    courseList.forEach(course => {
                        let courseNum = 0;
                        if (course.himozukeAdult == 1) {
                            courseNum += inputUserInfo.adultCnt;
                        }
                        if (course.himozukeChild == 1) {
                            courseNum += inputUserInfo.childCnt;
                        }
                        if (course.himozukeYoji == 1) {
                            courseNum += inputUserInfo.preschoolerCnt;
                        }
                        if (courseNum != 0) {
                            newCourseList.push({ courseCd: course.courseCd, courseName: course.courseName, courseNum: courseNum })
                            dispCourse += (dispCourse == "" ? "" : "、 ") + course.courseName + "：" + courseNum + "人";
                        }
                    })
                }
                let newList = [];
                mealInfoList.forEach((value, index) => {
                    let data = value;
                    if (index == popupData.targetIndex) {
                        data.mealTime = selectTime;
                        data.courseList = newCourseList;
                        data.dispCourse = dispCourse;
                        data.riyoNinzu = inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt;
                        data.adultCnt = inputUserInfo.adultCnt;
                        data.childCnt = inputUserInfo.childCnt;
                        data.preschoolerCnt = inputUserInfo.preschoolerCnt;
                        data.babyCnt = inputUserInfo.babyCnt;
                    }
                    newList.push(data);
                });
                setMealInfoList(newList);
            }
            setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
        } else if (popupMode == "otherMenuCourse") {
            let newCourseList = [];
            let dispCourse = "";
            dataList.forEach(value => {
                let courseNum = document.getElementById(value.courseCd).value;
                if (courseNum != "0") {
                    newCourseList.push({ courseCd: value.courseCd, courseName: value.courseName, courseNum: courseNum })
                    dispCourse += (dispCourse == "" ? "" : "、 ") + value.courseName + "：" + courseNum + "人";
                }
            });
            let newList = [];
            otherMenuInfoList.forEach((value, index) => {
                let data = value;
                if (index == popupData.targetIndex) {
                    data.menuCourseList = newCourseList;
                    data.dispCourse = dispCourse;
                }
                newList.push(data);
            });
            setOtherMenuInfoList(newList);
        } else if (popupMode == "shuttleBusTime") {
            let selectTimeList = document.getElementsByName("selectTime");
            let selectTime = "";
            selectTimeList.forEach(value => {
                if (value.checked) {
                    selectTime = value.value;
                }
            });
            if (selectTime != "") {
                setInputUserInfo({ ...inputUserInfo, busTime: selectTime })
            }
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
        if (popupMode != "course" && !errorFlg) {
            onClickClosePopupWindow();
        }
    }

    const getCourseDefaultNum = (popupData, value) => {
      const courseList = mealInfoList[popupData.targetIndex].courseList
      if (!courseList || courseList.length === 0) {
        return 0
      }
      const targetCourse = courseList.find(course => course.courseCd === value.courseCd)
      return targetCourse ? targetCourse.courseNum : 0
    }

    // 食事開始時間一覧取得後処理
    const afterGetMealStartTimeList = (res, ref) => {
        let data = res.data;
        if (data.resultCode == 0) {
            if (ref.changeFlg && ref.mealTime) {
                let startTimeList = data.startTimeList || [];
                startTimeList.forEach(value => {
                    if (value.startTime == ref.mealTime) {
                        value.akiFlg = true;
                    } 
                });
                setPopupData({
                    targetIndex: popupData.targetIndex,
                    selectTimeList: startTimeList
                });
            } else {
                setPopupData({
                    targetIndex: popupData.targetIndex,
                    selectTimeList: data.startTimeList
                });
            }
            onClickOpenPopupWindow("mealTime", popupData.targetIndex);
        } else {
            onClickClosePopupWindow();
        }
    }

    // 同意内容取得後処理
    const afterGetAgreeInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let newList = [];
            mealInfoList.forEach((value, index) => {
                let mealInfo = value;
                if (index == popupData.targetIndex) {
                    let newDoiList = [];
                    if (data.doiList) {
                        data.doiList.forEach(doiInfo => {
                            newDoiList.push({
                                doiTitle: doiInfo.doiTitle,
                                doiSetsumei: doiInfo.doiSetsumei,
                                doiSetsumeiURL: doiInfo.doiSetsumeiURL,
                                checked: false
                            });
                        })
                    }
                    mealInfo.restaurantCd = restaurantInfo.restaurantCd;
                    mealInfo.restaurantName = restaurantInfo.restaurantName;
                    mealInfo.riyoNinzu = inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt + inputUserInfo.babyCnt;
                    mealInfo.adultCnt = inputUserInfo.adultCnt;
                    mealInfo.childCnt = inputUserInfo.childCnt;
                    mealInfo.preschoolerCnt = inputUserInfo.preschoolerCnt;
                    mealInfo.babyCnt = inputUserInfo.babyCnt;
                    mealInfo.mealTime = "";
                    mealInfo.courseList = [];
                    mealInfo.dispCourse = "";
                    mealInfo.doiList = newDoiList;
                }
                newList.push(mealInfo);
            });
            setMealInfoList(newList);
        } else {
            onClickClosePopupWindow();
        }
    }

    // レストラン選択
    const onClickRestaurant = (restaurantCd, restaurantName) => {
        let riyoNinzuFlg = mealInfoList[popupData.targetIndex].riyoNinzuFlg;
        restaurantInfo.restaurantCd = restaurantCd;
        restaurantInfo.restaurantName = restaurantName;
        if (restaurantCd == "89" || restaurantCd == "88" || restaurantCd == "V0") {
            let newList = [];
            mealInfoList.forEach((value, index) => {
                let data = value;
                if (index == popupData.targetIndex) {
                    riyoNinzuFlg = data.riyoNinzuFlg
                    data.restaurantCd = restaurantCd;
                    data.restaurantName = restaurantName;
                    data.riyoNinzu = "";
                    data.mealTime = "";
                    data.dispMenuTime = "";
                    data.courseList = [];
                    data.dispCourse = "";
                    data.doiList = [];
                }
                newList.push(data);
            });
            setMealInfoList(newList);
            onClickClosePopupWindow();
        } else if (mealInfoList[popupData.targetIndex].required) {
            common.doPost(getCourseListFromPlan, {
                keiyakuNo: membershipSearchParam.keiyakuNo,
                honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                planCd: membershipReserveInfo.planCd,
                planShohinCd: membershipReserveInfo.planShohinCd,
                riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt,
                riyoDateFrom: membershipSearchParam.checkInDate,
                riyoDateTo: membershipSearchParam.checkOutDate
            }, afterGetCourseListFromPlan)
        } else {
            let reqAgreeInfo = {
                honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                shisetsuCd: membershipReserveInfo.shisetsuCd,
                restaurantCd: restaurantCd,
                cornerBunKbn: "1"
            }
            if (riyoNinzuFlg) {
                setPopupData({
                    targetIndex: popupData.targetIndex,
                });
                onClickOpenPopupWindow("riyoNinzu");
            } else {
                let reqMealStartTime = {
                    honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    restaurantCd: restaurantCd,
                    restaurantName: restaurantName,
                    riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
                    jikantaiKbn: mealInfoList[popupData.targetIndex].jikantaiKbn,
                    riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt,
                }
                let ref = {};
                if (membershipReserveInfo.changeFlg) {
                    let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[popupData.targetIndex].restaurantRiyoDate, "yyyy-MM-dd");
                    let dayCnt = dateList.length;
                    const foodTimeList = inputUserInfo.foodList?.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
                    const foodTimeInfo = foodTimeList?.find(value => value.jikantaiKbn == mealInfoList[popupData.targetIndex].jikantaiKbn)
                    if (foodTimeInfo) {
                        ref = {
                            changeFlg: true,
                            mealTime: foodTimeInfo.startTime
                        }
                    } else {
                        ref = {
                            changeFlg: false,
                        }
                    }
                    common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
                } else {
                    ref = {
                        changeFlg: false,
                    }
                    common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
                }
            }
            common.doPost(getAgreeInfo, reqAgreeInfo, afterGetAgreeInfo);
        }
    }

    // 食事コース一覧取得後処理
    const afterGetMealCourseList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setPopupData({
                targetIndex: popupData.targetIndex,
                courseList: data.courseList
            });
            onClickOpenPopupWindow("course", popupData.targetIndex);
        } else {
            onClickClosePopupWindow();
        }
    }

    // 時間選択ボタン
    const onClickSelectTime = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let adultCnt = riyoNinzuState.adult;
        let childCnt = riyoNinzuState.child;
        let preschoolerCnt = riyoNinzuState.preschooler;
        let babyCnt = riyoNinzuState.baby;
        let totalCnt = adultCnt + childCnt + preschoolerCnt + babyCnt;
        if (totalCnt === 0) {
            errorFlg = true;
            errorMessageBox.push(MessageConst.REQUIRE_INPUT_ERROR)
        } else if (totalCnt > Const.MAX_MEAL_CAPACITY) {
            errorFlg = true;
            errorMessageBox.push(MessageConst.VALID_INPUT_ERROR)
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
        if (!errorFlg) {
            let newList = [];
            mealInfoList.forEach((value, index) => {
                let data = value;
                if (index == popupData.targetIndex) {
                    data.riyoNinzu = totalCnt;
                    data.adultCnt = adultCnt;
                    data.childCnt = childCnt;
                    data.preschoolerCnt = preschoolerCnt;
                    data.babyCnt = babyCnt;
                    if (!membershipReserveInfo.changeFlg) {
                        data.mealTime = "";
                        data.dispMenuTime = "";
                        data.courseList = [];
                        data.dispCourse = "";
                    }
                }
                newList.push(data);
            });
            setMealInfoList(newList);
            let reqMealStartTime = {
                honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                shisetsuCd: membershipReserveInfo.shisetsuCd,
                restaurantCd: mealInfoList[popupData.targetIndex].restaurantCd,
                restaurantName: mealInfoList[popupData.targetIndex].restaurantName,
                riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
                jikantaiKbn: mealInfoList[popupData.targetIndex].jikantaiKbn,
                riyoNinzu: totalCnt,
            }
            let ref = {};
            if (membershipReserveInfo.changeFlg) {
                let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[popupData.targetIndex].restaurantRiyoDate, "yyyy-MM-dd");
                let dayCnt = dateList.length;
                const foodTimeList = inputUserInfo.foodList?.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
                const foodTimeInfo = foodTimeList?.find(value => value.jikantaiKbn == mealInfoList[popupData.targetIndex].jikantaiKbn)
                if (foodTimeInfo) {
                    ref = {
                        changeFlg: true,
                        mealTime: foodTimeInfo.startTime
                    }
                } else {
                    ref = {
                        changeFlg: false,
                    }
                }
                common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
            } else {
                ref = {
                    changeFlg: false,
                }
                common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
            }
        }
    }

    // コース選択ボタン
    const onClickSelectCourse = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let selectTimeList = document.getElementsByName("selectTime");
        let selectTime = "";
        selectTimeList.forEach(value => {
            if (value.checked) {
                selectTime = value.value;
            }
        });
        if (selectTime == "") {
            errorFlg = true;
            errorMessageBox.push(MessageConst.REQUIRE_INPUT_ERROR);
        } else {
            let newList = Array.from(mealInfoList);
            if (popupMode == "mealTime") {
                newList.forEach((value, index) => {
                    if (index == popupData.targetIndex) {
                        value.mealTime = selectTime;
                        if (!membershipReserveInfo.changeFlg) {
                            value.courseList = [];
                            value.dispCourse = "";
                        }
                    }
                });
                setMealInfoList(newList);
                let req = {
                    honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
                    shisetsuCd: membershipReserveInfo.shisetsuCd,
                    restaurantCd: mealInfoList[popupData.targetIndex].restaurantCd,
                    riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
                    jikantaiKbn: mealInfoList[popupData.targetIndex].jikantaiKbn
                }
                common.doPost(getMealCourseList, req, afterGetMealCourseList);
            } else if (popupMode == "otherMenuTime") {
                let date = "";
                menuDateList.forEach(value => {
                    if (value.selected) {
                        date = value.value;
                    }
                })
                otherMenuInfoList.forEach((value, index) => {
                    let data = value;
                    if (index == popupData.targetIndex) {
                        data.menuTime = selectTime;
                        data.menuDate = date;
                        data.dispMenuTime = commonUtil.getStringFromDateJpn(date) + selectTime.slice(0, 2) + ":" + selectTime.slice(2);
                        data.menuCourseList = [];
                        data.dispCourse = "";
                    }
                    newList.push(data);
                });
                setOtherMenuInfoList(newList);
                onClickOpenPopupWindow("otherMenuCourse", popupData.targetIndex);
            }
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }
    const onClickRadioForm = (id) => {
        let target = document.getElementById(id);
        target?.click();
    }

    // レストラン一覧取得後処理
    const afterGetRestaurantList = (res, ref) => {
        let data = res.data;
        if (data.resultCode == 0) {
            if (ref.changeFlg && ref.restaurantCd) {
                data.restaurantList.forEach(value => {
                    if (value.restaurantCd == ref.restaurantCd) {
                        value.mansekiFlg = false;
                    }
                })
            }
            setPopupData({
                dinnerTsukiPlanFlg: membershipReserveInfo.dinnerTsukiPlanFlg,
                breakfastTsukiPlanFlg: membershipReserveInfo.breakfastTsukiPlanFlg,
                restaurantList: data.restaurantList,
                targetIndex: popupData.targetIndex
            })
            let jikantaiKbn = mealInfoList[popupData.targetIndex].jikantaiKbn;
            if (jikantaiKbn == "2") {
                onClickOpenPopupWindow("dinner", popupData.targetIndex);
            } else if (jikantaiKbn == "3") {
                onClickOpenPopupWindow("breakfast", popupData.targetIndex);
            }
        }
    }

    // レストラン変更
    const onClickChangeRestaurant = () => {
        let req = {
            keiyakuNo: membershipSearchParam.keiyakuNo,
            honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            planCd: membershipReserveInfo.planCd,
            planShohinCd: membershipReserveInfo.planShohinCd,
            riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
            jikantai: mealInfoList[popupData.targetIndex].jikantaiKbn,
            riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt,
        }
        let ref = {};
        if (membershipReserveInfo.changeFlg && inputUserInfo.foodList) {
            let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[popupData.targetIndex].restaurantRiyoDate, "yyyy-MM-dd");
            let dayCnt = dateList.length;
            const foodTimeList = inputUserInfo.foodList.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
            const foodTimeInfo = foodTimeList.find(value => value.jikantaiKbn == mealInfoList[popupData.targetIndex].jikantaiKbn)
            if (foodTimeInfo) {
                ref = {
                    changeFlg: true,
                    restaurantCd: foodTimeInfo.restaurantCd
                }
            } else {
                ref = {
                    changeFlg: false,
                }
            }
        } else {
            ref = {
                changeFlg: false,
            }
        }
        common.doPostRef(getRestaurantList, req, ref, afterGetRestaurantList);
    }

    // 時間変更
    const onClickChangeMealTime = () => {
        let reqMealStartTime = {
            honkanShisetsuCd: membershipReserveInfo.honkanShisetsuCd,
            shisetsuCd: membershipReserveInfo.shisetsuCd,
            restaurantCd: mealInfoList[popupData.targetIndex].restaurantCd,
            restaurantName: mealInfoList[popupData.targetIndex].restaurantName,
            riyoDate: mealInfoList[popupData.targetIndex].restaurantRiyoDate,
            jikantaiKbn: mealInfoList[popupData.targetIndex].jikantaiKbn,
            riyoNinzu: inputUserInfo.adultCnt + inputUserInfo.childCnt + inputUserInfo.preschoolerCnt,
        }
        let ref = {};
        if (membershipReserveInfo.changeFlg) {
            let dateList = commonUtil.getDateList(membershipSearchParam.checkInDate, mealInfoList[popupData.targetIndex].restaurantRiyoDate, "yyyy-MM-dd");
            let dayCnt = dateList.length;
            const foodTimeList = inputUserInfo.foodList?.find(value => value.dayCnt == dayCnt) ? inputUserInfo.foodList.find(value => value.dayCnt == dayCnt).foodTimeList : [];
            const foodTimeInfo = foodTimeList?.find(value => value.jikantaiKbn == mealInfoList[popupData.targetIndex].jikantaiKbn)
            if (foodTimeInfo) {
                ref = {
                    changeFlg: true,
                    mealTime: foodTimeInfo.startTime
                }
            } else {
                ref = {
                    changeFlg: false,
                }
            }
            common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
        } else {
            ref = {
                changeFlg: false,
            }
            common.doPostRef(getMealStartTimeList, reqMealStartTime, ref, afterGetMealStartTimeList);
        }
    }

    // 人数変更
    const onClickChangeRiyoNinzu = () => {
        setPopupData({
            targetIndex: popupData.targetIndex,
        });
        onClickOpenPopupWindow("riyoNinzu");
    }

    const onClickMenuDate = (target) => {
        let newList = [];
        menuDateList.forEach((value, index) => {
            let data = value;
            if (index == target) {
                data.selected = true;
            } else {
                data.selected = false;
            }
            newList.push(data);
        })
        setMenuDateList(newList);
    }

    const getPopupText = () => {
        if (popupMode === 'doiInfo') {
            return popupData.doiInfo.doiSetsumei ? popupData.doiInfo.doiSetsumei : ""
        }
    }

    const popupBody = dataList ? dataList.map((value, index) => {
        if (popupMode == 'dinner' || popupMode == 'breakfast') {
            return <>
                {isMobilePhone ?
                    <div key={"restaurant" + index} className={"restaurantButton " + (value.mansekiFlg || value.closeFlg ? "disabledStyle" : "")} onClick={value.mansekiFlg || value.closeFlg ? "" : () => onClickRestaurant(value.restaurantCd, value.restaurantName)}>
                        <Label
                            label={value.restaurantName}
                        />
                        <Label
                            label={value.closeFlg ? " CLOSE" : value.mansekiFlg ? " 満席" : ""}
                            className="restaurantMansekilabel"
                        />
                    </div>
                    :
                    <div key={"restaurant" + index} className={index == dataList.length - 1 ? "restaurantButton lastRow " : "restaurantButton "} onClick={value.mansekiFlg || value.closeFlg ? "" : () => onClickRestaurant(value.restaurantCd, value.restaurantName)}>
                        <Label
                            label={value.restaurantName}
                        />
                        <Label
                            label={value.closeFlg ? " CLOSE" : value.mansekiFlg ? " 満席" : ""}
                            className="restaurantMansekilabel"
                        />
                    </div>
                }
            </>
        } else if (popupMode == 'mealTime') {
            return <>
                {value.akiFlg ?
                    <div key={"mealTime" + index} className={mealInfoList[popupData.targetIndex].riyoNinzuFlg ? errorInfo.errorFlg ? "errorMealTimeRadio2" : "mealTimeRadio2" : errorInfo.errorFlg ? "errorMealTimeRadio" : "mealTimeRadio"} onClick={() => onClickRadioForm(value.startTime + "0")} >
                        <RadioButtonForm
                            id={value.startTime}
                            data={[{ value: value.startTime, text: formatTime(value.startTime), id: value.startTime, checked: value.startTime == mealInfoList[popupData.targetIndex].mealTime }]}
                            name="selectTime"
                            inputClassName="inputRadioButtonGold"
                            labelClassName="timeRadioButton"
                        />
                    </div>
                    :
                    <div key={"mealTime" + index} className={mealInfoList[popupData.targetIndex].riyoNinzuFlg ? "mealTimeLabel2" : "mealTimeLabel"} >
                        <Label
                            className="mealTimeCross"
                        />
                        <Label
                            label={formatTime(value.startTime)}
                            className="mansekiTimeLabel"
                        />
                    </div>
                }
            </>
        } else if (popupMode == 'shuttleBusTime') {
            return <>
                {isMobilePhone ?
                    <div key={"shuttleBusTime" + index} className={errorInfo.errorFlg ? "errorMealTimeRadio" : "mealTimeRadio"} onClick={() => onClickRadioForm(value + "0")} >
                        <RadioButtonForm
                            id={value}
                            data={[{ value: value, text: value.slice(0, 2) + ":" + value.slice(2), id: value, checked: value == inputUserInfo.busTime }]}
                            name="selectTime"
                        />
                    </div>
                    :
                    <div key={"shuttleBusTime" + index} className={errorInfo.errorFlg ? "errorMealTimeRadio" : "mealTimeRadio"} onClick={() => onClickRadioForm(value + "0")} >
                        <RadioButtonForm
                            id={value}
                            data={[{ value: value, text: value.slice(0, 2) + ":" + value.slice(2), id: value, checked: value == inputUserInfo.busTime }]}
                            name="selectTime"
                        />
                    </div>
                }
            </>
        } else if (popupMode == 'course') {
            return <>
                {isMobilePhone ?
                    <div key={"course" + index} className={"courseRow"}  >
                        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "column", width: "75%", marginLeft: "5%" }}>
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.price.toLocaleString() + "（税・サ込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    title={""}
                                    divClass="coursePullDown2"
                                    labelClassName="pullDownCourseName"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={getCourseDefaultNum(popupData, value)}
                                />
                            )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                    :
                    <div key={"course" + index} className={"courseRow"}  >
                        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "column", width: "75%", marginLeft: "5%" }}>
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.price.toLocaleString() + "（税・サ込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    title={""}
                                    divClass="coursePullDown2"
                                    labelClassName="pullDownCourseName"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={getCourseDefaultNum(popupData, value)}
                                />
                            )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                }
            </>
        } else if (popupMode == "otherMenuTime") {
            return <>
                {isMobilePhone ?
                    <div key={"otherMenuTime" + index} className={errorInfo.errorFlg ? "errorMealTimeRadio" : "mealTimeRadio"} onClick={() => onClickRadioForm(value + "0")} >
                        <RadioButtonForm
                            id={value}
                            data={[{ value: value, text: value.slice(0, 2) + ":" + value.slice(2), id: value, checked: value == otherMenuInfoList[popupData.targetIndex].menuTime }]}
                            name="selectTime"
                        />
                    </div>
                    :
                    <div key={"otherMenuTime" + index} className={errorInfo.errorFlg ? "errorMealTimeRadio" : "mealTimeRadio"} onClick={() => onClickRadioForm(value + "0")} >
                        <RadioButtonForm
                            id={value}
                            data={[{ value: value, text: value.slice(0, 2) + ":" + value.slice(2), id: value, checked: value == otherMenuInfoList[popupData.targetIndex].menuTime }]}
                            name="selectTime"
                        />
                    </div>
                }
            </>
        } else if (popupMode == 'otherMenuCourse') {
            return <>
                {isMobilePhone ?
                    <div key={"otherMenuCourse" + index} className={"courseRow"}  >
                        {
                        courseNumList.length === 0 ? null : (
                            <PullDownOptionForm
                                id={value.courseCd}
                                title={value.courseName}
                                divClass="coursePullDown2"
                                selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum" : "pullDownCourseNum2"}
                                data={courseNumList}
                                defaultValue={otherMenuInfoList[popupData.targetIndex].menuCourseList && otherMenuInfoList[popupData.targetIndex].menuCourseList.find(course => course.courseCd == value.courseCd) ? otherMenuInfoList[popupData.targetIndex].menuCourseList.find(course => course.courseCd == value.courseCd).courseNum : 0}
                            />
                        )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                    :
                    <div key={"otherMenuCourse" + index} className={"courseRow"}  >
                        {
                        courseNumList.length === 0 ? null : (
                            <PullDownOptionForm
                                id={value.courseCd}
                                title={value.courseName}
                                divClass="coursePullDown2"
                                selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum" : "pullDownCourseNum2"}
                                data={courseNumList}
                            />
                        )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                }
            </>
        }
    }) : null;

    const clear = () => {
      if(popupMode == "mealTime"){
        if(!!mealInfoList[popupData.targetIndex].mealTime){
          onClickRadioForm(`${mealInfoList[popupData.targetIndex].mealTime}0`);
        }else{
          document.getElementsByName('selectTime').forEach(r => r.checked = false);
        }
      }else if(popupMode == "course"){
        dataList.forEach(d => {
          const targetValue = mealInfoList[popupData.targetIndex].courseList?.find(course => course.courseCd  == d.courseCd)?.courseNum || 0;
          document.getElementById(d.courseCd).value = String(targetValue);
        })
      }

      onClickClosePopupWindow();
    }

    return (
        <div className={state.membershipPopup ? "restaurantPopupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={isMobilePhone ? "inputUserPopupInner_media" : "inputUserPopupInner"}>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={clear} />
                    <h4 className="popupInnerText" >{popupMode == "doiInfo" ? popupData.doiInfo.doiTitle : popupMode == "serviceInfo" ? popupData.serviceInfo.serviceTitle : popupTitle}</h4>
                </div>
                <div className={errorInfo.errorFlg ? "errorDiv" : "hiddenItem"}>
                    <ErrorMassage data={errorInfo.errorMessageBox} />
                </div>
                <div className={popupMode == "mealTime" || popupMode == "shuttleBusTime" || popupMode == "otherMenuTime" ? "radioWrapper" : "popupBodyWrapper"}>
                    {popupMode == "mealTime" || popupMode == "course" || popupMode == "riyoNinzu" ?
                        <div className="restaurantNameWrapper">
                            <Label
                                label={mealInfoList ? mealInfoList[popupData.targetIndex].restaurantName : ""}
                                className="restaurantNameLabel"
                            />
                            <Button
                                buttonText="レストラン変更"
                                className="changeBtn"
                                onClick={onClickChangeRestaurant}
                            />
                        </div>
                        : null}
                        {(popupMode == "mealTime" || popupMode == "course") && mealInfoList[popupData.targetIndex].riyoNinzuFlg ?
                        <div className="restaurantNameWrapper">
                            <Label
                                label={mealInfoList ? mealInfoList[popupData.targetIndex].riyoNinzu + "人" : ""}
                                className="restaurantNameLabel"
                            />
                            <Button
                                buttonText="人数変更"
                                className="changeBtn"
                                onClick={onClickChangeRiyoNinzu}
                            />
                        </div>
                        : null}
                    {popupMode == "course" ?
                        <div className="restaurantNameWrapper">
                            <Label
                                label="時間"
                            />
                            <div className="courseTime">
                                <Label
                                    label={mealInfoList && mealInfoList[popupData.targetIndex].mealTime ? formatTime(mealInfoList[popupData.targetIndex].mealTime) : ""}
                                    className="courseTimeLabel"
                                />
                                <Button
                                    buttonText="時間変更"
                                    className="changeBtnTime"
                                    onClick={onClickChangeMealTime}
                                />
                            </div>
                        </div>
                        : null}
                    {popupMode == "shuttleBusTime" ?
                        <div className="landingWrapper">
                            <Label
                                label="乗り場"
                                className="restaurantNameLabel"
                            />
                            <Label
                                label={popupData.landing}
                            />
                        </div>
                        : null}
                    {popupMode == "otherMenuTime" ?
                        <>
                            <div className="restaurantNameWrapper">
                                <Label
                                    label={otherMenuInfoList ? otherMenuInfoList[popupData.targetIndex].menuName : ""}
                                    className="restaurantNameLabel"
                                />
                            </div>
                            <div className="radioWrapper">
                                {menuDateList.map((value, index) =>
                                    <Button
                                        buttonText={value.text}
                                        className={value.selected ? "selectedStyle" : "notSelectedStyle"}
                                        onClick={() => onClickMenuDate(index)}
                                    />
                                )}
                            </div>
                        </>
                        : null}
                    {popupMode == "otherMenuCourse" ?
                        <>
                            <div className="restaurantNameWrapper">
                                <Label
                                    label={otherMenuInfoList ? otherMenuInfoList[popupData.targetIndex].menuName : ""}
                                    className="restaurantNameLabel"
                                />
                            </div>
                            <div className="restaurantNameWrapper">
                                <Label
                                    label="時間"
                                />
                                <div className="courseTime">
                                    <Label
                                        label={otherMenuInfoList ? otherMenuInfoList[popupData.targetIndex].menuTime.slice(0, 2) + ":" + otherMenuInfoList[popupData.targetIndex].menuTime.slice(2) : ""}
                                        className="courseTimeLabel"
                                    />
                                    <Button
                                        buttonText="変更"
                                        className="changeBtnTime"
                                        onClick={() => onClickOpenPopupWindow("mealTime", popupData.targetIndex)}
                                    />
                                </div>
                            </div>
                        </>
                        : null}
                    {popupMode == "riyoNinzu" ?
                        <>
                            <div className='inputHunmanNumWrapper'>
                                <PullDownOptionForm
                                    title={"大人"}
                                    labelClassName="inputHunmanNumLabel"
                                    id={"riyoAdultCnt"}
                                    divClass="inputHunmanNum"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                    data={adultNumList}
                                    state={riyoNinzuState.adult}
                                    onChange={(e) => handleChangeSelect(e, 'adult')}
                                />
                                <Label
                                    label="人"
                                />
                            </div>
                            <div className='inputHunmanNumWrapper'>
                                <PullDownOptionForm
                                    title={"小学生"}
                                    labelClassName="inputHunmanNumLabel"
                                    id={"riyoChildCnt"}
                                    divClass="inputHunmanNum"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                    data={childNumList}
                                    state={riyoNinzuState.child}
                                    onChange={(e) => handleChangeSelect(e, 'child')}
                                />
                                <Label
                                    label="人"
                                />
                            </div>
                            <div className='inputHunmanNumWrapper'>
                                <PullDownOptionForm
                                    title={"幼児(3歳～5歳)"}
                                    labelClassName="inputHunmanNumLabel"
                                    id={"riyoPreschoolerCnt"}
                                    divClass="inputHunmanNum"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                    data={preschoolerNumList}
                                    state={riyoNinzuState.preschooler}
                                    onChange={(e) => handleChangeSelect(e, 'preschooler')}
                                />
                                <Label
                                    label="人"
                                />
                            </div>
                            <div className='inputHunmanNumWrapper'>
                                <PullDownOptionForm
                                    title={"乳児(0歳～2歳)"}
                                    labelClassName="inputHunmanNumLabel"
                                    id={"riyoBabyCnt"}
                                    divClass="inputHunmanNum"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                                    data={babyNumList}
                                    state={riyoNinzuState.baby}
                                    onChange={(e) => handleChangeSelect(e, 'baby')}
                                />
                                <Label
                                    label="人"
                                />
                            </div>
                        </>
                        : null}
                    {popupMode == "serviceInfo" || popupMode == "error" ?
                        <div className="messageClass" >
                            <div id="popupText">
                            </div>
                        </div>
                        :
                        <>
                            {popupMode === "doiInfo" ?
                                <div className="messageClass" >
                                    <div id="popupText">
                                        {getPopupText()}
                                    </div>
                                    {popupData.doiInfo && popupData.doiInfo.doiSetsumeiURL ?
                                        <a href={popupData.doiInfo.doiSetsumeiURL} target="_blank" rel="noopener noreferrer"> {"「" + popupData.doiInfo.doiTitle + "」について"} </a>
                                        : null}
                                </div>
                                :
                                <>
                                    {popupBody}
                                </>
                            }
                        </>
                    }
                    {(popupMode == "dinner" && !popupData.dinnerTsukiPlanFlg) || (popupMode == "breakfast" && !popupData.breakfastTsukiPlanFlg) ?
                        <>
                            <div className={popupMode == "dinner" ? "hiddenItem" : "restaurantButton2"} onClick={() => onClickRestaurant("89", "朝食不要")}>
                                <Label
                                    label="朝食不要"
                                />
                            </div>
                            <div className={popupMode == "breakfast" ? "hiddenItem" : "restaurantButton2"} onClick={() => onClickRestaurant("88", "夕食不要")}>
                                <Label
                                    label="夕食不要"
                                />
                            </div>
                            <div className="restaurantButton2" onClick={() => onClickRestaurant("V0", "未定")}>
                                <Label
                                    label="未定"
                                />
                            </div>
                        </>
                        : null}
                </div>
                <div className={footerClass == "decision" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="conditionSearch" onClick={onClickDecide} buttonClassName="buttonText" buttonText="決定" />
                </div>
                <div className={footerClass == "selectTime" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="conditionSearch" onClick={onClickSelectTime} buttonClassName="buttonText" buttonText="時間選択へ" />
                </div>
                <div className={footerClass == "selectCourse" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="button" onClick={onClickSelectCourse} buttonClassName="buttonText" buttonText="コース選択へ" />
                </div>
                <div className={footerClass == "message" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="button" onClick={() => onClickClosePopupWindow()} buttonClassName="buttonText" buttonText="OK" />
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

// 時間の成形処理
const formatTime = (timeStr) => {
    // 時間にコロンを付与
    const timeWithColon = timeStr.slice(0, 2) + ":" + timeStr.slice(2);
    
    // 先頭のゼロを削除
    return timeWithColon.replace(/^0+/, '');
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        mealInfoList: state.mealInfoList,
        otherMenuInfoList: state.otherMenuInfoList,
        inputUserInfo: state.inputUserInfo,
        membershipSearchParam: state.membershipSearchParam,
        membershipReserveInfo: state.membershipReserveInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setOtherMenuInfoList: (item) => {
            dispatch({ type: "OTHER_MENU_INFO_LIST", payload: { otherMenuInfoList: item } })
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(InputUserPopupContainer);